export default {
  add: 'Add service',
  ambulance: 'Ambulance',
  hotel: 'Accommodation',
  salon: 'Salon',
  service: 'Service | Services',
  shelter: 'Shelter',
  trainer: 'Training',
  walking: 'Walking'
}



// WEBPACK FOOTER //
// ./src/i18n/en/routes/services.js